import { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import NotFound from "../pages/NotFound";
import ProductPage from "../pages/product/page";
import TallowProductPage from "../pages/product-tallow/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/jawline-support-strap",
    element: <ProductPage />,
  },
  {
    path: "/product/beef-tallow-cream",
    element: <TallowProductPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
